import React from 'react';
import {useSearchParams} from 'react-router-dom';
import {Box, Center, Heading, Text} from '@chakra-ui/react';
import {SalesforceErrorsDownloader} from './SalesforceErrorsDownloader';

export const SalesforceErrors = () => {
  const [searchParams] = useSearchParams();

  const customerId = searchParams.get('customerId');
  const jobIds = searchParams.get('jobIds');

  if (!jobIds) {
    return (
      <Box p={8}>
        <Heading size="md" mb={4}>
          Missing Parameters
        </Heading>
        <Text>
          This page requires a jobId query parameter to download Salesforce
          errors.
        </Text>
      </Box>
    );
  }

  return (
    <Center p={8}>
      <SalesforceErrorsDownloader
        rawCustomerId={customerId}
        jobIds={jobIds.split(',')}
      />
    </Center>
  );
};
